import {COLORS} from '../utils/style-variables';

export const chevronDown = {
  '&:after': {
    content: '""',
    borderStyle: 'solid',
    borderWidth: '2px 2px 0 0',
    borderColor: COLORS.greyColor,
    display: 'inline-block',
    position: 'absolute',
    width: 8,
    height: 8,
    top: 'calc(50% - 6px)',
    right: 10,
    transform: 'rotate(135deg)',
    verticalAlign: 'top',
    '@media (max-width: 768px)': {
      top: 4,
      right: 2
    }
  }
};

export const angleDown = {

};

export const sortIcon = {
  '&:before': {
    content: '""',
    position: 'absolute',
    right: 0,
    top: 'calc(50% - 6px)',
    width: 0,
    height: 0,
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderBottomStyle: 'solid',
    borderBottomWidth: 5,
    borderBottomColor: COLORS.lightGrey100Color
  },
  '&:after': {
    content: '""',
    position: 'absolute',
    right: 0,
    bottom: 'calc(50% - 6px)',
    width: 0,
    height: 0,
    borderLeft: '4px solid transparent',
    borderRight: '4px solid transparent',
    borderTopStyle: 'solid',
    borderTopWidth: 5,
    borderTopColor: COLORS.lightGrey100Color
  }
};

export const infoIcon = {
  '&:before': {
    position: 'absolute',
    content: '""',
    right: 8,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 2,
    height: 10,
    borderStyle: 'solid',
    borderWidth: 0,
    borderTopWidth: 2,
    borderBottomWidth: 6,
    borderColor: COLORS.lightGrey100Color
  },
  '&:after': {
    position: 'absolute',
    content: '""',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 18,
    height: 18,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: COLORS.lightGrey100Color
  }
};
